export default __webpack_public_path__ + "static/media/image-chair-algo-q-7-w.c7f8aee0.png";